import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { FinancialNonPaymentModel } from './types';
import { financialNonPaymentItemValidator } from './validators/item';

const financialNonPaymentValidator: ValidateJSModel<FinancialNonPaymentModel> = {
  HasNonpayment: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasNonpayment?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialNonPaymentItemValidator },
      };
    }

    return {};
  },
};

export default financialNonPaymentValidator;
